module.exports = __webpack_public_path__ + "static/media/msc_logo.d82e8d3e.png";